import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import BannerLanding from '../components/BannerLanding'
//import { Grid, Row, Col } from 'react-flexbox-grid';

const pageTitle = "Infrastructure";
const pageContent = ["Besoin de conseils ou d'audits pour votre SI ? ", "Besoin spécifiques pour votre infrastructure ? ", "Un projet de développement ou de restructuration ?"];

const Generic = (props) => (
	<div style={props.transition && props.transition.style}>
		<Helmet>
			<title>Web 2 Alpes - Assistance, conseil et audits des systèmes d'information</title>
			<meta name="description" content="Assistance, conseil et audits des systèmes d'information" />
			<meta name="language" content="fr-FR" />
            <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
            <meta http-equiv="content-language" content="fr-FR" />
		</Helmet>
		<BannerLanding title={pageTitle} content={pageContent} particles="infra" />
		<div id="main" className="alt">
			<section id="support" className="tiles">
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Votre infrastructure</h2>
						</header>
						<p className="preul"><strong>Ingénieur systèmes réseaux et sécurité</strong>, j'interviens sur toute infrastructure d'une dizaine de postes à plusieurs milliers. (Pour un parc plus petit, voir <Link to="/assistance-informatique/">ici</Link>). Je vous aide à <strong>mettre en place une nouvelle infrastructure ou faire évoluer la vôtre</strong> :</p>
						<ul className="snow">
							<li><strong>Analyse de vos besoins</strong></li>
							<li><strong>Audit</strong> (détection des failles et des axes d’amélioration)</li>
							<li><strong>Mise en œuvre</strong> (étude, conception et réalisation)</li>
						</ul>
						<p className="bordertop">Vous trouverez le détail de mes compétences dans <strong><Link to="/cv/">mon CV</Link></strong>.</p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Une infra adaptee</h2>
						</header>
						<p>Selon vos besoins et vos pratiques, je peux optimiser votre infrastructure en favorisant travail collaboratif et mobilité (gestion centralisée et partages de documents sur intranet ou internet...)</p>
						<p>Votre système d’information doit maintenant respecter le cadre légal européen (GDPR) et peut être soumis à des obligations spécifiques relatives à votre activité. Je peux vérifier sa conformité et le mettre aux normes.</p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Une infra economique</h2>
						</header>
						<p>Concevoir un dispositif automatisant un maximum de tâches permet de gagner beaucoup de temps.</p>
						<p className="preul">Vous pouvez également réduire vos frais d’installation et de fonctionnement :</p>
						<ul className="snow">
							<li>en privilégiant l'open source gratuit,</li>
							<li>en négociant le prix de vos licences,</li>
							<li>en évitant de surdimmensionner les services mis en place ...</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Mes garanties</h2>
						</header>
						<ul className="snow">
							<li>Une infrastructure <strong>sécurisée et conforme à la loi</strong></li>
							<li><strong>Un système d’informations efficace</strong>, centré sur vos besoins et pratiques</li>
							<li><strong>Une optimisation économique</strong> à court, moyen et long terme</li>
							<li><strong>Des interventions flexibles</strong> : à la demande, ponctuelles ou suivies, sur l’ensemble du système ou seulement une partie</li>
							<li><strong>Une veille technologique et administrative constante</strong> : je vous informe sur les nouveautés et les changements légaux vous concernant</li>
						</ul>
						<p className="bordertop">N’hésitez pas à <strong><Link to="#contact">me contacter</Link></strong> pour un devis gratuit.</p>
					</div>
				</article>
			</section>
		</div>
	</div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/infrastructure-informatique.js